<template>
	<!-- Particle js используем как динамический фон -->
	<div class="dynamic-background" id="particleJS-container"></div>
</template>

<script>
import { defineComponent } from 'vue';
import 'particles.js';

export default defineComponent({
	name: 'dynamic-background',

	computed: {
		isPhoneSize() {
			return this.$q.screen.name === 'xs';
		}
	},

	created() {
		// Этот код полностью был скопирован из старого чата
		this.$nextTick(() => {
			window.particlesJS('particleJS-container', {
				particles: {
					number: {
						value: this.isPhoneSize === 'mobile' ? 20 : 80,
						density: {
							enable: true,
							value_area: 800
						}
					},
					color: {
						value: '#fff'
					},
					shape: {
						type: 'circle',
						stroke: {
							width: 0,
							color: '#000000'
						},
						polygon: {
							nb_sides: 5
						}
					},
					opacity: {
						value: 0.5,
						random: false,
						anim: {
							enable: false,
							speed: 1,
							opacity_min: 0.1,
							sync: false
						}
					},
					size: {
						value: 5,
						random: true,
						anim: {
							enable: false,
							speed: 40,
							size_min: 0.1,
							sync: false
						}
					},
					line_linked: {
						enable: true,
						distance: 150,
						color: '#fff',
						opacity: 0.4,
						width: 1
					},
					move: {
						enable: true,
						speed: 3,
						direction: 'none',
						random: false,
						straight: false,
						out_mode: 'out',
						bounce: false,
						attract: {
							enable: false,
							rotateX: 600,
							rotateY: 1200
						}
					}
				},
				interactivity: {
					detect_on: 'canvas',
					events: {
						onhover: {
							enable: true,
							mode: 'grab'
						},
						onclick: {
							enable: true,
							mode: 'push'
						},
						resize: true
					},
					modes: {
						grab: {
							distance: 140,
							line_linked: {
								opacity: 1
							}
						},
						bubble: {
							distance: 400,
							size: 40,
							duration: 2,
							opacity: 8,
							speed: 3
						},
						repulse: {
							distance: 200,
							duration: 0.4
						},
						push: {
							particles_nb: 4
						},
						remove: {
							particles_nb: 2
						}
					}
				},
				retina_detect: true
			});
		});
	}
});
</script>

<style lang="scss" scoped>
.dynamic-background {
	position: fixed;
	top: 0;
	width: 100%;
	height: 100vh;
}
</style>
